import CallToAction from '../CallToAction'
import Link from 'components/Link'
import React from 'react'
import * as ProductIcons from 'components/ProductIcons'
import * as NotProductIcons from 'components/NotProductIcons'
import * as OtherIcons from 'components/Icons/Icons'
import { Wrapper } from '../Wrapper'
import { graphql, useStaticQuery } from 'gatsby'
import { useLocation } from '@reach/router'
import { useTranslation } from 'gatsby-plugin-react-i18next'

export const MenuItem = (item) => {
    const { url, icon, enable, description, description_ar, title, title_ar } = item
    const { i18n } = useTranslation()
    const Icon = ProductIcons[icon] || NotProductIcons[icon] || OtherIcons[icon]
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    return (
        <li className="md:max-w-[100px]">
            <Link
                className="group relative flex h-full cursor-pointer flex-col items-center justify-start space-y-2 rounded-sm py-2 hover:top-[-.5px] hover:scale-[1.01] hover:bg-tan hover:bg-opacity-50 active:top-[.5px] active:scale-[.99] md:px-2"
                to={url}
            >
                {Icon && (
                    <span className="h-7 w-7  opacity-60 group-hover:opacity-100 dark:text-white">{<Icon />}</span>
                )}
                <h3 className="m-0 text-center text-sm font-bold leading-none opacity-70">
                    {/* {i18n.language === 'ar' && title_ar}
                {i18n.language === 'en' && title} */}
                    {title}
                </h3>
            </Link>
        </li>
    )
}
export const MenuItem2 = (item) => {
    const { url, icon, enable, description, description_ar, title, title_ar } = item
    const Icon = ProductIcons[icon] || NotProductIcons[icon] || OtherIcons[icon]
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    return (
        <li key={title} className="flex h-full max-w-[235px] items-start space-x-2 rounded-sm py-2 md:px-2">
            <div className="shrink-0 grow-0 basis-[24px]">
                {Icon && <span className="h-7 w-7  opacity-60 dark:text-white">{<Icon />}</span>}
            </div>
            <Link
                className="group relative flex h-full cursor-pointer flex-col items-center justify-start space-y-2 rounded-sm py-2 hover:top-[-.5px] hover:scale-[1.01] hover:bg-tan hover:bg-opacity-50 active:top-[.5px] active:scale-[.99] md:px-2"
                to={url}
            >
                <div className="mt-1 flex-1">
                    <h3 className="m-0 text-[15px] font-bold leading-none opacity-70">{title}</h3>
                    <p className="mt-1 mb-0 text-xs  opacity-60 dark:text-white">{description}</p>
                </div>
            </Link>
        </li>
    )
}

const iconClasses = 'h-[25px]  dark:text-white'

export default function Product({ referenceElement, menuItem }) {
    const { customers } = useStaticQuery(query)
    // const  customers = customers?.nodes?.customers
    const { linkList } = menuItem
    const totalCount = customers?.totalCount
    const { pathname } = useLocation()

    return (
        <Wrapper borderRadius="0px 0.375rem 0.375rem" referenceElement={referenceElement} placement="bottom-start">
            <div className="rounded-md md:flex">
                {linkList?.length > 0 &&
                    linkList.map((linkListItem, index) => {
                        const { items, title, enable } = linkListItem
                        if (
                            (enable === false || enable?.toLowerCase?.() === 'false') &&
                            !process.env.RENDER_DISABLED_COMPONENTS
                        ) {
                            return null
                        }
                        return (
                            <section
                                key={`section-${index}`}
                                className="flex flex-col border-r border-dashed border-gray-accent-light p-6"
                            >
                                {items?.length > 0 &&
                                    items.map((item, index2) => {
                                        const {
                                            url,
                                            subitems,
                                            enable,
                                            subtitle,
                                            subtitle_ar,
                                            title,
                                            type,
                                            style,
                                            title_ar,
                                            description,
                                            description_ar,
                                        } = item
                                        if (
                                            (enable === false || enable?.toLowerCase?.() === 'false') &&
                                            !process.env.RENDER_DISABLED_COMPONENTS
                                        ) {
                                            return null
                                        }
                                        return (
                                            <div key={`item-${index}-${index2}`}>
                                                {type != 'CallToAction' ? (
                                                    <>
                                                        <h3 className="m-0 pl-2 text-[18px] font-bold text-black">
                                                            {title}
                                                        </h3>
                                                        <p className="text-75 mb-0  pl-2 text-sm  opacity-50 dark:text-white">
                                                            {subtitle}
                                                        </p>
                                                        <ol className="mx-0 mt-2 mb-6 grid list-none grid-cols-3 space-x-[1px] p-0">
                                                            {/* <ol className="-mx-6 mt-2 mb-6 grid list-none grid-cols-2 space-x-[1px] border-b border-dashed border-gray-accent-light p-0 px-6 pb-4 dark:border-gray-accent-dark md:grid-cols-4"> */}
                                                            {subitems?.length > 0 &&
                                                                subitems.map((subItem, index3) => {
                                                                    if (
                                                                        (subItem === false ||
                                                                            subItem?.toLowerCase?.() === 'false') &&
                                                                        !process.env.RENDER_DISABLED_COMPONENTS
                                                                    ) {
                                                                        return null
                                                                    }
                                                                    return (
                                                                        <MenuItem2
                                                                            key={`subitem-${index}-${index2}-${index3}`}
                                                                            {...subItem}
                                                                        />
                                                                    )
                                                                })}
                                                        </ol>
                                                    </>
                                                ) : (
                                                    <CallToAction
                                                        className="mt-auto inline-block !w-full"
                                                        to={subitems?.[0]?.url}
                                                    >
                                                        {title}
                                                    </CallToAction>
                                                )}
                                            </div>
                                        )
                                    })}
                            </section>
                        )
                    })}
            </div>
        </Wrapper>
    )
}

{
    /*     <section className="bg-gray-accent-light bg-opacity-10 py-6 px-3"> */
}
{
    /*      <h3 className="m-0 pl-3 text-[18px] font-bold text-black/70">Core Platform</h3>
                    <ol className="m-0 mt-2 max-w-[250px] list-none p-0">
                        <Link
                            className="relative mb-1 block rounded-sm py-2 px-3 hover:bg-tan hover:bg-opacity-50 active:top-[1px] active:scale-[.99]"
                            to="/real-estate-analytics"
                        >
                            <EventPipelines className={iconClasses} />
                            Analytics
                            <p className="m-0 mt-1 text-sm font-medium leading-tight  opacity-50 dark:text-white">
                                Real estate analytics
                            </p>
                        </Link>
                        <Link
                            className="relative mb-1 block rounded-sm py-2 px-3 hover:bg-tan hover:bg-opacity-50 active:top-[1px] active:scale-[.99]"
                            to="/real-estate-platform"
                        >
                            <Integrations className={iconClasses} />
                            Integrations
                            <p className="m-0 mt-1 text-sm font-medium leading-tight  opacity-50 dark:text-white">
                                Real estate integration hub
                            </p>
                        </Link>
                       <Link
                            className="rounded-sm py-2 px-3 block hover:bg-tan hover:bg-opacity-50 relative active:top-[1px] active:scale-[.99]"
                            to="/customers/industrial"
                        >
                            <Industrial className={iconClasses} />
                            Office, Industrial, Retail
                            <p className="text-sm opacity-50 m-0  font-medium dark:text-white mt-1 leading-tight">
                                Used iCloudReady real estate marketing to cut failure rates by 90%
                            </p>
                        </Link>
                    </ol> */
}
{
    /* <CallToAction
                        className="mt-4 !w-full inline-flex items-center justify-center space-x-1"
                        to="/customers"
                    >
                        <span>All customers</span>{' '}
                        <span className="opacity-50">
                            (<span className="inline-block mx-0">{totalCount}</span>)
                        </span>
                    </CallToAction> */
}
{
    /* </section> */
}
const query = graphql`
    {
        customers: allMdx(filter: { fields: { slug: { regex: "/^/customers/" } } }, limit: 3) {
            nodes {
                id
                fields {
                    slug
                }
                frontmatter {
                    logo {
                        childImageSharp {
                            gatsbyImageData(placeholder: NONE)
                        }
                    }
                    title
                }
            }
            totalCount
        }
    }
`
